import PatientCharts from "./components/PatientCharts/PatientCharts.vue";

const routes: any = [
    {
        path: "/axxess-central/patients/patient-charts",
        component: PatientCharts,
        name: "patient-charts",
        meta: {
            menuName: "Patient Charts",
            navItem: "tabPatientCharts",
            showAxxessCentral: true
        }
    }
];

export default routes;
